import React from "react";
import { UserPlus } from "lucide-react";

/**
 * Shown in place of the table when there are no owners yet.
 */
export default function EmptyState({ onAddOwner }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-theme-200 px-6 py-12 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
        <UserPlus className="h-5 w-5 text-primary" aria-hidden="true" />
      </div>
      <h4 className="mt-4 font-sans text-sm font-semibold text-theme-900">
        No owners yet
      </h4>
      <p className="mt-1 max-w-xs font-sans text-sm text-theme-500">
        Add an owner to start assigning them to workflow stages.
      </p>
    </div>
  );
}
